/** --- 审批 approvalStatus --- */

export const ORDER_APPROVAL_STATUS_VALUES = ['approved', 'systemApproved', 'inProcessOfApproval', 'reject'];

/** 业务上视为「已审批」的状态（人工通过 + 系统自动通过） */
export const ORDER_APPROVAL_STATUS_APPROVED_VALUES = ['approved', 'systemApproved'];

export const ORDER_APPROVAL_STATUS_LABELS = {
	inProcessOfApproval: '审批中',
	reject: '审批驳回',
	approved: '审批通过',
	systemApproved: '系统审批通过',
};

/** --- 财务 paymentStatus（库内 5 段 + 列表派生 pendingFinalCostConfirmation） --- */

export const ORDER_PAYMENT_STATUS_VALUES = ['waitingPayPlaceOrder', 'waitingPayDelivery', 'waitingPayAccept', 'waitingPayCredit', 'payComplete'];

export const ORDER_PAYMENT_STATUS_FILTER_VALUES = [...ORDER_PAYMENT_STATUS_VALUES, 'pendingFinalCostConfirmation'];

export const ORDER_PAYMENT_STATUS_LABELS = {
	waitingPayPlaceOrder: '待收预付款',
	waitingPayDelivery: '待收发货款',
	waitingPayAccept: '待收验收款',
	waitingPayCredit: '待收还款',
	payComplete: '支付完成',
	pendingFinalCostConfirmation: '待确认最终成本',
};

/** --- 物流 deliveryStatus（3 段） --- */

export const ORDER_DELIVERY_STATUS_VALUES = ['waitingDelivery', 'waitingAccept', 'logisticsComplete'];

export const ORDER_DELIVERY_STATUS_LABELS = {
	waitingDelivery: '待发货',
	waitingAccept: '待验收',
	logisticsComplete: '物流完成',
};

/** --- 关单 isCompleted（筛选/query 字符串口径） --- */

export const ORDER_COMPLETION_FILTER_VALUES = ['true', 'false'];

export const ORDER_COMPLETION_FILTER_LABELS = {
	true: '已关单',
	false: '未关单',
};
